// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"6068f288","153":"1a367938","206":"668ba440","833":"0d9d295d"}[chunkId] + ".chunk.css";
};